import Blue from "~/core";
import screen from "~/utils/_screen.js";

new Blue({
  name: 'Market Data Navigation',
  selector: ".marketData-navigation",
  setup(nav) {
    const title = nav.querySelector('.marketData-navigationTitle');
    const wrapper = nav.querySelector('.marketData-navigationWrapper');
    const icon = nav.querySelector('.js-mobileIcon');

    const iconClass = {
      open: "fa-caret-up",
      closed: "fa-caret-down"
    };

    let mobileVisible = false;

    init();



    // ---------------
    // Functions
    // ---------------

    function init() {
      title.addEventListener('click', clickHandler);
      window.addEventListener('resize', resizeHandler);
      resizeHandler();
    }

    function clickHandler() {
      if (isVisible()) 
        toggleMenu();
    }

    function resizeHandler() {
      const visible = isVisible();

      if (visible !== mobileVisible) {
        if (!visible) 
          toggleMenu(false);
        mobileVisible = visible;
      }
    }

    function isVisible() {
      return screen.lg_dn.matches;
    }

    function toggleMenu(force) {
      if (isVisible()) {
        wrapper.classList.toggle('active', force);
        icon.classList.toggle(iconClass.open, force);
        icon.classList.toggle(iconClass.closed, !force);
      }
    }
  }
});